import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css';

window.fpmVarietyGallery = function (swiper) {
	return {
		init: ($refs) => {
			swiper = new Swiper($refs.container, {
				autoHeight: true,
				init: false,
				loop: false,
				centeredSlides: true,
				slidesPerView: 1,
				spaceBetween: 0,
			})

			swiper.init()
		},
		slidePrev: () => {
			swiper.slidePrev()
		},
		slideNext: () => {
			swiper.slideNext()
		}
	}
}

// When a SKU image is clicked, load a larger sized image in a modal.
document.addEventListener('click', (e) => {
	if ( ! e.target.classList.contains('expand-modal') ) {
		return;
	}

	const variationId = e.target.dataset.openVariation;
	const variation = document.querySelector(`[data-variation="${variationId}"`);
	variation.classList.remove('hidden', 'pointer-events-none');
	variation.classList.add('flex');
} );

// When the the SKU modal overlay is clicked, close the modal.
document.addEventListener('click', (e) => {
	if ( ! e.target.classList.contains('variation_background_overlay') ) {
		return;
	}

	e.target.classList.add('hidden', 'pointer-events-none');
	e.target.classList.remove('flex');
} );
